import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of } from 'rxjs'

export const GetIntermediatesStatusEpic: Epic = (action$, _, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchIntermediatesStatus.match),
    mergeMap((action) =>
      OrderRepository.getIntermediatesStatus(action.payload.orderId).pipe(
        mergeMap((result) => of(order.fetchIntermediatesStatusResult({ result }))),
        catchError((error: Error) => {
          console.warn('could not load the intermediates status', error)
          return of(order.fetchIntermediatesStatusResult({ result: null }))
        })
      )
    )
  )
